import i18n from '@/i18n';

export const formatCardCountdown = (targetIso: string, now: number): string => {
  const diffMs = new Date(targetIso).getTime() - now;
  if (diffMs <= 0) return '';
  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86_400);
  const hours = Math.floor((totalSeconds % 86_400) / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  if (days > 0) return i18n.t('countdown.day', { count: days });
  if (hours > 0) return `${hours}h ${mins}m`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
};
